const prepareRenewInformation = ({ renewInfo, formToken }) => {
	return {
		...renewInfo,
		...(formToken && { form_token: formToken })
	};
};

export default prepareRenewInformation;
